var base = require('settings/teams/generate-team-token');

Vue.component('spark-generate-team-token', {
    mixins: [base]
});
